import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Journal() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      const data = await res.json().catch(() => ({}));
      toast.success(
        data.welcome === false
          ? "You're already on the list — use WELCOME10 for 10% off your first order."
          : "Welcome — your 10% off code WELCOME10 is on its way to your inbox."
      );
      setEmail("");
    } catch {
      toast.error("Something went wrong — please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section
      id="journal"
      data-testid="journal-section"
      className="relative bg-[#6E5B8E] py-20 md:py-24 overflow-hidden"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <Reveal>
          <h3 className="font-sans text-2xl md:text-[2rem] text-white leading-snug">
            Join the VIVORÉ Journal
          </h3>
          <p className="mt-3 font-sans font-light text-sm md:text-base text-white/70">
            Join the VIVORÉ list and receive 10% off your first order.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <form
            data-testid="newsletter-form"
            onSubmit={subscribe}
            className="flex flex-col sm:flex-row gap-4 sm:justify-end"
          >
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="w-full sm:max-w-[340px] bg-white text-ink border border-white/40 focus:border-lav outline-none rounded-xl px-6 py-4 font-light text-sm placeholder:text-stone/70 transition-colors duration-500"
            />
            <button
              data-testid="newsletter-submit-button"
              type="submit"
              disabled={sending}
              className="group bg-ivory text-ink font-sans text-[11px] uppercase tracking-widest2 rounded-xl px-8 py-4 flex items-center justify-center gap-2.5 hover:bg-lav hover:text-white transition-colors duration-500 disabled:opacity-60"
            >
              {sending ? "Joining…" : "Sign up"}
              <ArrowRight
                size={14}
                strokeWidth={1.5}
                className="transition-transform duration-500 group-hover:translate-x-1"
              />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
